import axios from "axios";
import store from "../store/store";
import ApiMethods from "../js/api-methods"
const qs = require('qs');

export default class CustomersService {

  async getCustomers(query) {
    try {
      let cancelToken = axios.CancelToken.source()
      store.commit("SET_SEARCH_CANCEL_TOKEN", cancelToken)
      const response = await axios.get(ApiMethods.GET_CUSTOMERS, { params: query, cancelToken: cancelToken.token }  );
      if (response.data && response.data.rows) {
        store.commit("SET_SEARCH_CANCEL_TOKEN", null)
        return response.data
      }else{
        response.data.method = 'GET_CUSTOMERS';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(axios.isCancel(e)) return { isCanceled: true }
      if(e && e.response && e.response.data) e.response.data.method = 'GET_CUSTOMERS';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }

  async getPreEditCustomerInfo(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.GET_PRE_EDIT_CUSTOMER_INFO, data );
      if (!response.data.MajorCode) {
        return response.data
      }else{
        response.data.method = 'GET_PRE_EDIT_CUSTOMER_INFO';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'GET_PRE_EDIT_CUSTOMER_INFO';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }

  async getTopCustomersByUnits(query) {
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.GET_TOP_CUSTOMERS_BY_UNITS, data  );
      if (response.data && response.data.Data) {
        return response.data.Data
      }else{
        response.data.method = 'GET_TOP_CUSTOMERS_BY_UNITS';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'GET_TOP_CUSTOMERS_BY_UNITS';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }

  async getTopAgentsByCustomers(query) {
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.GET_TOP_AGENTS_BY_CUSTOMERS, data  );
      if (response.data && response.data.Data) {
        return response.data.Data
      }else{
        response.data.method = 'GET_TOP_AGENTS_BY_CUSTOMERS';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'GET_TOP_AGENTS_BY_CUSTOMERS';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }

  async CustomerResetPassword(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.CUSTOMER_RESET_PASSWORD, data );
      if (response.data.MajorCode === '000') {
        return response.data
      }else{
        response.data.method = 'CUSTOMER_RESET_PASSWORD';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_RESET_PASSWORD';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }

  async CustomerDelete(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.CUSTOMER_DELETE, data );
      if (response.data.MajorCode === '000') {
        return response.data
      }else{
        response.data.method = 'CUSTOMER_DELETE';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_DELETE';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }
  async CustomerSuspend(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.CUSTOMER_DISABLE, data );
      if (response.data.MajorCode === '000') {
        return response.data
      }else{
        response.data.method = 'CUSTOMER_DISABLE';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_DISABLE';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }
  async CustomerUnSuspend(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.CUSTOMER_ENABLE, data );
      if (response.data.MajorCode === '000') {
        return response.data
      }else{
        response.data.method = 'CUSTOMER_ENABLE';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_ENABLE';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }
  async editCustomerInfo(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.CUSTOMER_EDIT, data );
      if (response.data.MajorCode === '000') {
        return response.data.Data
      }else{
        response.data.method = 'CUSTOMER_EDIT';
        /*response.data.query = query;
        response.data.sendErrorEmail = true;
        response.data.saveError = true;*/
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'CUSTOMER_EDIT';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }
  async sendCustomerRegLetter(query){
    try {
      let data = qs.stringify(query)
      const response = await axios.post(ApiMethods.SEND_CUSTOMER_REG_LETTER, data );
      if (response.data.MajorCode === '000') {
        return response.data
      }else{
        response.data.method = 'SEND_CUSTOMER_REG_LETTER';
        store.commit('SET_ERROR', response.data)
        return false
      }

    } catch (e) {
      if(e && e.response && e.response.data) e.response.data.method = 'SEND_CUSTOMER_REG_LETTER';
      store.commit('SET_ERROR',  !e.response ? e : (!e.response.data) ? e.response : e.response.data)
      throw e
    }
  }
}